import { render, staticRenderFns } from "./TablaSeriesTodos.vue?vue&type=template&id=57387b38&"
import script from "./TablaSeriesTodos.vue?vue&type=script&lang=ts&"
export * from "./TablaSeriesTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('57387b38', component.options)
    } else {
      api.reload('57387b38', component.options)
    }
    module.hot.accept("./TablaSeriesTodos.vue?vue&type=template&id=57387b38&", function () {
      api.rerender('57387b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasServicio/TablaSeriesTodos.vue"
export default component.exports